/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S7_HeadingInputs */

const tr_servis_s7_heading = /** @type {(inputs: Servis_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Alt Yüklenici (Sub-Processor) Değişikliği`)
};

const en_servis_s7_heading = /** @type {(inputs: Servis_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Sub-Processor Change`)
};

const de_servis_s7_heading = /** @type {(inputs: Servis_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Wechsel des Unterauftragsverarbeiters (Sub-Processor)`)
};

const ru_servis_s7_heading = /** @type {(inputs: Servis_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Изменение субподрядчика (Sub-Processor)`)
};

/**
* | output |
* | --- |
* | "7. Sub-Processor Change" |
*
* @param {Servis_S7_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s7_heading = /** @type {((inputs?: Servis_S7_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S7_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s7_heading(inputs)
	if (locale === "de") return de_servis_s7_heading(inputs)
	if (locale === "ru") return ru_servis_s7_heading(inputs)
	return tr_servis_s7_heading(inputs)
});